import { makeAutoObservable } from 'mobx';
import apiService from 'Service'
import defaultValues from 'Constants/DefaultValues'
import providersStore from './providersStore'
import uiStore from './uiStore';
import AppNotifications from 'Constants/AppNotifications/AppNotifications';
import { toApiCivilDate } from 'Utilities/dateTime'

class invoicesStore {
  isLoading = true
  amounts = []

  invoice = defaultValues.invoice

  constructor() {
    makeAutoObservable(this)
  }

  updateInvoiceState(newData) {
    this.invoice = { ...this.invoice, ...newData }
  }

  setIsLoading(value) {
    this.isLoading = value
  }

  resetProcess() {
    this.setIsLoading(true)
    this.invoice = defaultValues.invoice
    this.setIsLoading(false)
  }

  buildCompleteDocumentPayload() {
    const provider = providersStore.provider
    const providerId = provider?.Id || this.invoice.IdProvider
    if (!providerId) throw new Error('not_valid_provider_id')

    const totalCompra = this.amounts.reduce((sum, a) => sum + (Number(a.TotalAmmount) || 0), 0)
    const taxIva = this.amounts.reduce((sum, a) => sum + (Number(a.TaxAmmount) || 0), 0)
    const percentage = Number(provider?.WithholdingPercentageIVA) || Number(this.invoice.WithholdingPercentage) || 0
    const ivaRetenido = Math.round((taxIva * (percentage / 100)) * 100) / 100

    return {
      Invoice: {
        ...this.invoice,
        IdProvider: providerId,
        Rif: this.invoice.Rif || provider?.Rif || '',
        BusinessName: this.invoice.BusinessName || provider?.BusinessName || '',
        Address: this.invoice.Address || provider?.FiscalAddress || '',
        Phone: this.invoice.Phone || provider?.PhoneNumber || '',
        WithholdingPercentage: percentage,
        WithholdingAmmount: ivaRetenido,
        Total: totalCompra,
        EmitDate: toApiCivilDate(this.invoice.EmitDate),
      },
      InvoiceDetails: this.amounts,
      InvoicePays: [defaultValues.invoicePay],
      TotalCompraConIva: totalCompra,
      IvaRetenido: ivaRetenido,
      IsNotWithholding: this.invoice.IsNotWithholding,
      PorcentajeRetencion: percentage,
    }
  }

  updateCompleteDocument(invoiceId) {
    this.setIsLoading(true)
    return apiService.DocumentCompletes.update(invoiceId, this.buildCompleteDocumentPayload())
      .then(data => {
        this.setIsLoading(false)
        return data
      })
      .catch(err => {
        this.setIsLoading(false)
        throw err
      })
  }

  postNewCompleteDocument() {
    this.setIsLoading(true)
    return apiService.DocumentCompletes.add(this.buildCompleteDocumentPayload()).then(data => {
      this.setIsLoading(false)
      return data
    }).catch(() => {
      this.setIsLoading(false)
    })
  }

  updateOnService(newData) {
    this.setIsLoading(true)
    this.updateInvoiceState(newData)
    return apiService.Providers.update(this.invoice).then(data => {
      this.updateInvoiceState(data)
      this.setIsLoading(false)
      return true
    }
    ).finally(() => this.setIsLoading(false))
  }

  initProcess(defaultInvoice, defaultAmounts) {
    this.setIsLoading(true)
    this.invoice = {
      ...defaultValues.invoice,
    }
    if(defaultInvoice){
      this.invoice = {
        ...defaultInvoice
      }
    }
    this.amounts = []
    if(defaultAmounts){
      this.amounts = [...defaultAmounts]
    }
    this.setIsLoading(false)
  }
  
  addAmount(amountData) {
    this.amounts.push({ ...defaultValues.invoiceDetail, ...amountData })
  }

  deleteAmount(row) {
    this.amounts = [...this.amounts.filter(x => x.Row !== row)]
  }

  clear() {
    this.isLoading = true
    this.invoice = defaultValues.invoice
    this.amounts = []
  }

  async deleteInvoice(invoice) {
    const result = await apiService.InvoiceDocuments.deleteInvoice(invoice)
    if (result.status === 200) {
      uiStore.addNotification(AppNotifications.INVOICE_DELETE_SUCCESS)
    } else {
      uiStore.addNotification(AppNotifications.INVOICE_DELETE_FAIL)
    }
    return result.status === 200
  }
}

export default new invoicesStore();
